import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  UpgradePlanLock_OfferLockDataFragment,
  UpgradePlanLock_ViewerFragment,
} from './__generated__/upgrade-plan-lock.graphql'
import styles from './upgrade-plan-lock.module.scss'
import { UpgradePlanLockContent } from './upgrade-plan-lock-content'

export interface UpgradePlanLockProps {
  offerLockData: UpgradePlanLock_OfferLockDataFragment
  viewer: UpgradePlanLock_ViewerFragment
}

export function UpgradePlanLock({ offerLockData, viewer }: UpgradePlanLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = <UpgradePlanLockContent viewer={viewer} offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles['paywall-two-offers-lock']}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return <ModalLock offerLockBody={offerLockData.body}>{content}</ModalLock>
    default:
      return null
  }
}

UpgradePlanLock.fragments = {
  offerLockData: gql`
    fragment UpgradePlanLock_offerLockData on OfferLockData {
      ...UpgradePlanLockContent_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${UpgradePlanLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment UpgradePlanLock_viewer on Profile {
      ...UpgradePlanLockContent_viewer
    }
    ${UpgradePlanLockContent.fragments.viewer}
  `,
}
